import { Injectable } from '@angular/core';
import { AWS_PASSPHRASE_CONSTANT } from '../constants/contents.constants';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  decoder = new TextDecoder('utf-8');
  passPhase: CryptoKey | null = null;
  appConfigs = window['config'];

  constructor() { }

  async importKeyFromString(keyStr: string): Promise<CryptoKey> {
    const keyData = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(keyStr));
    return crypto.subtle.importKey(
          'raw',
          keyData,
          { name: 'AES-CBC' },
          false,
          ['encrypt', 'decrypt']
        );
  }

  async decrypt(encryptedData: ArrayBuffer): Promise<string> {
    let decryptedData: string = '';
    
    if (!this.passPhase) {
      console.log('Passphrase is not set.');
      return decryptedData;
    }

    if(encryptedData) {
      const decryptedBuffer = await crypto.subtle.decrypt(
        { name: 'AES-CBC', iv: new Uint8Array(16) },
        this.passPhase,
        encryptedData
      );
      decryptedData = this.decoder.decode(decryptedBuffer);
    }
    return decryptedData;
  }

  hexToArrayBuffer(hexStringData: string) {
    if(hexStringData !== '' && hexStringData !== null) {
      const bytes = new Uint8Array(hexStringData.length / 2);
      for (let i = 0; i < hexStringData.length; i += 2) {
        bytes[i / 2] = parseInt(hexStringData.substr(i, 2), 16);
      }
      return bytes.buffer;
    }
  }

  async generatePassPhase() {
    if (this.appConfigs?.appId) {
      this.passPhase = await this.importKeyFromString(this.appConfigs.appId + AWS_PASSPHRASE_CONSTANT);
    } else {
      this.passPhase = null;
    }
  }
}
